import { defineComponent as _defineComponent } from 'vue'
import { mdiCartOutline } from '@mdi/js'
import type { Ticket } from '@/features/tickets/composables/usePricing'
import { ITicketCartResponse } from '@/features/tickets/types'
import { centsToDollars } from '@/services/currency'
import { ref, watch } from 'vue'

interface Props {
  cartSummary: ITicketCartResponse | undefined
  getTicketById: (ticketId: number) => Ticket | undefined
  isLoading: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderSummary',
  props: {
    cartSummary: null,
    getTicketById: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  cartSummary: ITicketCartResponse | undefined
  getTicketById: (ticketId: number) => Ticket | undefined
  isLoading: boolean
};



const localCartSummary = ref(props.cartSummary)

watch(
  () => props.cartSummary,
  (newVal) => {
    localCartSummary.value = newVal
  }
)

return { __sfc: true,props, localCartSummary, mdiCartOutline, centsToDollars }
}

})